<template lang="pug">
.custom-select
   label.settings-input-label {{label}}
   .relative
      select.settings-select(v-bind:value="value" v-on:input="updateValue($event.target.value)")
         option(v-for="option in options", v-bind:value='option.type') {{option.name}}
      .select-icon-wrap
         .select-icon
</template>

<script>

export default {
  props: {
    label: String,
    options: Array,
    value: ''
  },
  computed: {
    thisModel () {
      return this.model
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/Dropdown.vue